import { useNavigate } from 'react-router-dom';

import Logo from '../../assets/logo-dark.png';
import Styles from './Headers.module.css';

const Header = () => {
  const navigate = useNavigate();
  return (
    <div className={Styles.headerContainer}>
      <img className={Styles.logoIcon} src={Logo} alt={'Website logo'} />
      <div className={Styles.headerButtons}>
        <button
          className={`${Styles.btn} ${Styles.btnSecondary}`}
          onClick={() => navigate('/access')}
        >
          Enter School Code
        </button>
        <button
          className={`${Styles.btn} ${Styles.btnSecondary}`}
          onClick={() => navigate('/login')}
        >
          Log In
        </button>
        <button
          className={`${Styles.btn} ${Styles.btnPrimary}`}
          onClick={() => navigate('/signup')}
        >
          Sign Up
        </button>
      </div>
    </div>
  );
};

export default Header;
